import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import ImageFormStyle from './ImageFormStyle'
import type { ImageFormBrandType, ImageBrandForms } from './imageTypes'

const FORM_MAP: ImageBrandForms = {
  [BrandFormEnum.STYLE]: ImageFormStyle,
}

const ImageFormBrand: ImageFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(ImageFormBrand) as typeof ImageFormBrand
